import { Popover, Spin, Typography } from "antd";
import { useWidgetRefreshing } from "../Contexts/dashboardHooks";
import { sliceColor, type ControllerOption } from "../Processing/controllerBindings";

const { Text } = Typography;

/**
 * One small filled disc per slicer the widget follows, colored by that slicer's
 * slice_color. Hovering a disc opens a white Popover card naming the slicer — the same
 * style as the info icon's popover. WidgetInfoButton renders the discs just right of the
 * info icon in the widget header; a widget without an info icon renders them alone in the
 * same slot.
 */
export function SlicerBadgeDiscs({ controllers }: { controllers: ControllerOption[] }) {
  if (controllers.length === 0) return null;
  return (
    <>
      {controllers.map((c) => {
        const color = sliceColor(c.spec.slicer_builder_misc);
        return (
          <Popover
            key={c.uuid}
            trigger="hover"
            placement="bottomRight"
            content={
              <div className="slicer-badge-popover">
                <span className="slicer-badge-disc" style={{ background: color }} />
                <Text style={{ fontSize: 12 }}>
                  Controlled by Slicer: <Text strong style={{ fontSize: 12 }}>{c.label}</Text>
                </Text>
              </div>
            }
          >
            <span className="slicer-badge-disc" style={{ background: color }} />
          </Popover>
        );
      })}
    </>
  );
}

/**
 * The corner strip left of the ⋯ menu. It now carries only the refresh spinner (a slicer
 * edit awaiting fresh data); the slicer discs moved into the widget header, next to the
 * info icon (see WidgetInfoButton).
 */
export function ConnectedSlicerBadges({ id }: { id: string }) {
  const refreshing = useWidgetRefreshing(id);
  if (!refreshing) return null;
  return (
    <div className="widget-corner-overlay">
      <span className="widget-refresh-spinner" role="status" aria-label="Updating">
        {/* antd's default dot-cluster indicator, per design request — not LoadingOutlined. */}
        <Spin size="small" />
      </span>
    </div>
  );
}
